import '../sp-statistic-control/sp-statistic-control';
import '../sp-statistic-slide/sp-statistic-slide-field-flow';
import '../sp-statistic-slide/sp-statistic-slide-field-ranking';
import '../sp-statistic-slide/sp-statistic-slide-user-ranking';
import '../sp-statistic-slide/sp-statistic-slide-spot-ranking';

import {customElement, property, query, state} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {
    SpStatisticField,
    SpStatisticFieldUpdatedEventPayload,
    SpStatisticPeriod,
    SpStatisticPeriodUpdatedEventPayload
} from '../sp-statistic-control/sp-statistic-control';
import {SpStatisticFieldValue} from '../sp-statistic-slide/sp-statistic-slide-field-flow';
import {register} from 'swiper/element/bundle';
import {translate} from '@stefanholzapfel/lit-translate';
import {repeat} from 'lit-html/directives/repeat.js';
import Swiper from 'swiper';
import {styles} from './sp-statistic-panel.styles';

register();

interface HTMLSwiperElement extends HTMLElement {
    swiper?: Swiper;
}

@customElement('sp-statistic-panel')
export class SpStatisticPanel extends LitElement {

    static styles = [
        // perfectScrollbar,
        styles
    ];

    @state()
    slides: SpStatisticSlide[] = [];
    @property({type: Array})
    fields: SpStatisticField[];
    @property({type: Array})
    fieldSelected: SpStatisticField
    @property()
    period: SpStatisticPeriod;
    @property({type: String})
    start: string = '';
    @property()
    slideSelected: SpStatisticSlide = null;
    @property({type: Boolean})
    showUpdates: Boolean;
    @property({type:Boolean})
    enableSwiper: Boolean = true;

    @query("swiper-container", true)
    _swiperElement: HTMLSwiperElement | undefined | null;

    // scrollbarController = new SpScrollbarController(this);

    firstUpdated() {
        const children = Array.from(this.children);
        children.forEach((child, index) => {
            child.setAttribute('slot', `slot-${index}`);
            this.slides.push(<"user-ranking" | "spot-ranking" | "field-ranking" | "field-flow">child.id);
        });

        this.requestUpdate();
        if (this.slideSelected == null) this.slideSelected = this.slides[0];
        this._swiperElement.swiper.slideTo(this.slides.indexOf(this.slideSelected));
    }

    render() {
        const children = Array.from(this.children);
        return html`
            <ul class="header-buttons">
                ${repeat(this.slides ? this.slides : [], (slide, index) => html`
                    <li class="circle ${slide}">
                        <a @click=${() => {
                            this.openSlide(index)
                        }} class="${this.slideSelected == slide ? 'selected' : ''}"></a>
                    </li>
                `)}
            </ul>
            <swiper-container speed="${this.enableSwiper ? 300 : 0}" simulate-touch="${this.enableSwiper ? true : false}" @swiperslidechangetransitionstart=${() => {
                if (!this._swiperElement.swiper) return;
                this.slideSelected = this.slides[this._swiperElement.swiper.activeIndex];
                this.dispatchPanelSlideUpdate();
            }}>
                ${children.map((child, index) => html`
                            <swiper-slide class="${child.id + '-slide'}">
                                <div class="slide-title">
                                    ${translate(`STATISTICS_${child.id.replace('-', '_').toUpperCase()}_TITLE`)}
                                </div>
                                <div class="fade-out-top"></div>
                                <div class="slide-content">
                                    <slot name="slot-${index}"></slot>
                                </div>
                                <div class="fade-out-bottom"></div>
                            </swiper-slide>
                        `
                )}
            </swiper-container>
            <sp-statistic-control
                    .fields=${this.fields}
                    .field=${this.fieldSelected}
                    .fieldSelectEnabled=${this.slideSelected == 'field-ranking' || this.slideSelected == 'field-flow'}
                    .period=${this.period}
                    @statistic-period-updated=${this.dispatchPanelPeriodUpdate}
                    @statistic-field-updated=${this.dispatchPanelFieldUpdate}>
            </sp-statistic-control>
        `;
    }

    //<slot @slotchange=${this.handleSlotchange}></slot>

    // handleSlotchange(e) {
    //     const assignedElements = e.target.assignedElements({flatten: true});
    //     assignedElements.forEach(element => {
    //         if (element.nodeName !== 'SWIPER-SLIDE') {
    //
    //             const slide = document.createElement('swiper-slide');
    //             slide.classList.add(element.id + '-slide');
    //             this._swiperElement.appendChild(slide);
    //             // element.parentElement.insertBefore(slide, element);
    //
    //             const slideCss = document.createElement('style');
    //             slideCss.textContent = slideStyles.cssText;
    //             slide.appendChild(slideCss);
    //
    //             const slideTitle = document.createElement('div');
    //             slideTitle.classList.add('slide-title');
    //             render(html`${translate(`STATISTICS_${element.id.replace('-', '_').toUpperCase()}_TITLE`)}`, slideTitle);
    //             slide.appendChild(slideTitle);
    //
    //             const fadeOutTop = document.createElement('div');
    //             fadeOutTop.classList.add('fade-out-top');
    //             slide.appendChild(fadeOutTop);
    //
    //             element.classList.add('slide-content');
    //             slide.appendChild(element);
    //
    //             const fadeOutBottom = document.createElement('div');
    //             fadeOutBottom.classList.add('fade-out-bottom');
    //             slide.appendChild(fadeOutBottom);
    //
    //             this.slides.push(element.id);
    //         }
    //     });
    //     this.requestUpdate();
    //     if (this.slideSelected == null) this.slideSelected = this.slides[0];
    //     this._swiperElement.swiper.slideTo(this.slides.indexOf(this.slideSelected));
    // }

    // firstUpdated(_changedProperties: PropertyValues) {
    //     super.firstUpdated(_changedProperties);
    //     let slides = this.shadowRoot.querySelectorAll('.slide-content');
    //     slides.forEach((slide) => {
    //         console.log('slide', slide);
    //         this.scrollbarController.add(slide);
    //     });
    //     //this.scrollbarController.add(this.renderRoot.querySelector('.slide-content'));
    // }
    //
    // updated(_changedProperties: PropertyValues) {
    //     let slides = this.shadowRoot.querySelectorAll('.slide-content');
    //     //dispatchUpdateScrollbarsEvent(this.renderRoot.getElementById('#user-ranking-slide'), true);
    //     slides.forEach((slide) => {
    //         console.log('slide', slide);
    //         dispatchUpdateScrollbarsEvent(slide, true);
    //     });
    // }

    private openSlide(index: number) {
        this._swiperElement.swiper.slideTo(index, this.enableSwiper ? 300 : 0); //300
    }

    private dispatchPanelPeriodUpdate(e: CustomEvent<SpStatisticPeriodUpdatedEventPayload>) {
        this.period = e.detail.period;
        this.dispatchEvent(new CustomEvent<SpStatisticPanelPeriodUpdatedEventPayload>('statistic-panel-period-updated', {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                period: e.detail.period
            }
        }));
    }

    private dispatchPanelSlideUpdate() {
        this.dispatchEvent(new CustomEvent<SpStatisticPanelSlideUpdatedEventPayload>('statistic-panel-slide-updated', {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                slide: this.slideSelected,
            }
        }));
    }

    private dispatchPanelFieldUpdate(e: CustomEvent<SpStatisticFieldUpdatedEventPayload>) {
        this.fieldSelected = e.detail.field;
        this.dispatchEvent(new CustomEvent<SpStatisticPanelFieldUpdatedEventPayload>('statistic-panel-field-updated', {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                field: e.detail.field
            }
        }));
    }
}

export interface SpStatisticPanelPeriodUpdatedEventPayload {
    period: SpStatisticPeriod
}

export interface SpStatisticPanelSlideUpdatedEventPayload {
    slide: SpStatisticSlide
}

export interface SpStatisticPanelFieldUpdatedEventPayload {
    field: SpStatisticField
}

export interface SpStatisticPanelFieldValuesUpdatedEventPayload {
    fieldValues: SpStatisticFieldValue[]

}

export type SpStatisticSlide = 'user-ranking' | 'spot-ranking' | 'field-ranking' | 'field-flow';